// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StoreDetails_wrapper__GT1Va","title":"StoreDetails_title__utYy7","cards":"StoreDetails_cards__sinUX","osakaChangesEnabled":"StoreDetails_osakaChangesEnabled__PwyOF"};